import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './OptChain.css';
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner'


function OptChain(props) {
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [Optiondata, setOptiondata] = useState([])

    const [Optiondatacall, setOptiondatacall] = useState([]);
    const [type, settype] = useState('put');
    const [DateDrp, setDate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    let getSymbol = props.symbolFandO;
    const [OptionDate, setOptionDate] = useState([]);
    // const [Symbol, setSymbol] = useState('Nifty');
    // let navigate = useNavigate();
    const [OptionSymbol, setOptionSymbol] = useState([]);
    const [OptionStrike, setOptionStrike] = useState([]);
    const [StrikePriceFando, setStrikePriceFando] = useState('-');
    const [loadingshow, setloadingshow] = useState(false);
    const [valueschemename, setValueschemename] = useState([]);
    let getOptionChains, getOptionDate, getOptionSymbol,
        getOptionChainscall, getOptionStrike, getUrldate;
    let PageSize = 8;



    useEffect(() => {
        window.scrollTo(0, 0)
        setloadingshow(true)
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${getSymbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
                var codename = getOptionDate[0].ExpiryDateText.split(' ').join('-');
                setValueschemename(codename.split(' ').join('-'))

                const getUrlOptionChains = BaseURL + "Optionschain";
                fetch(`${getUrlOptionChains}/${getSymbol}/${codename}/-/-`)
                    .then((response) => response.json())
                    .then((dataOptionChains) => {
                        getOptionChains = dataOptionChains.data;
                        setOptiondata(getOptionChains);
                        setloadingshow(false)
                        // console.log(getOptionChains, "getOptionChains")
                    })
                    .catch((error) => {
                    });

            })
            .catch((error) => {
            });
    }, [])


    useEffect(() => {
        const getUrldate = BaseURL + "FandOExpDateandSymbol";
        fetch(`${getUrldate}/opt/${getSymbol}`)
            .then((response) => response.json())
            .then((dataOptionDate) => {
                getOptionDate = dataOptionDate.data;
                setOptionDate(getOptionDate);
                setloadingshow(false);
            })


        const getUrlOptionChains = BaseURL + "Optionschain";
        fetch(`${getUrlOptionChains}/${getSymbol}/${DateDrp}/-/-`)
            .then((response) => response.json())
            .then((dataOptionChains) => {
                getOptionChains = dataOptionChains.data;
                setOptiondata(getOptionChains);
                setloadingshow(false)
                // console.log(getOptionChains, "getOptionChains")
            })
            .catch((error) => {
            });

    }, [DateDrp])



    return (

        <Container>
            <Row>
                <Col sm={12}>
                    <section className='snapsh-loser-sc'>
                        <div className='snapsh-right'>
                            <div className='snapsh-inner-select'>
                                <select id="select-date" onChange={(event) =>  setDate(event.target.value) }>
                                    <option value={(OptionDate != null && OptionDate[0] != null) ? OptionDate[0].ExpiryDateText : ''}>Select Expiry Date</option>
                                    {OptionDate && OptionDate.map(
                                        ({ ExpiryDateText }) => (
                                            <option value={ExpiryDateText.split(' ').join('-')} selected={valueschemename === ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                                        )
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className='snapsh-table table-responsive fixTableHeadComp'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className="bdrbottom bdrright" colSpan={3}></th>
                                        <th className="bdrright bdrbottom text-center" colSpan={3}>Calls</th>
                                        <th className="bdrbottom text-center" colSpan={3}>Puts</th>
                                    </tr>
                                    <tr>
                                        <th className='text-left'>Symbol</th>
                                        <th className='text-right'>Expiry Date</th>
                                        <th className='text-center bdrright'>Strike Price (&#8377;)</th>
                                        <th className='text-center'>Last Price(&#8377;)</th>
                                        <th className='text-center'>Change(&#8377;)</th>
                                        <th className='text-center bdrright'>Open Interest</th>
                                        <th className='text-center'>Last Price(&#8377;)</th>
                                        <th className='text-center'>Change(&#8377;)</th>
                                        <th className='text-center'>Open Interest</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Optiondata && Optiondata.map(
                                        ({ strikeprice, CallPricePerChange, PutPriceperChange, CallVolume, CallOI, CallOIChange, callbestbuyprice, Putbestbuyprice, callbestsellprice, Putbestsellprice, CallLTP, PutLTP, symbol, expdate, PutOI, PutOIChange, PutVolume }) => (
                                            <tr>
                                                <td className='text-left'>{symbol}</td>
                                                <td className='text-right'>{format(parseISO(expdate.split('T')[0]), 'dd-MMM-yyyy')}</td>
                                                <td className='text-right bdrright'>{strikeprice != null ? strikeprice : 0}</td>
                                                <td className='text-right'>{CallLTP != null ? CallLTP : 0}</td>
                                                <td className='text-right'>{CallPricePerChange != null ? CallPricePerChange.toFixed(2) : 0}</td>
                                                <td className='text-right bdrright'>{CallOI != null ? CallOI.toFixed(2) : 0}</td>
                                                <td className='text-right'>{PutLTP != null ? PutLTP : 0}</td>
                                                <td className='text-right'>{PutPriceperChange != null ? PutPriceperChange.toFixed(2) : 0}</td>
                                                <td className='text-right'>{PutOI != null ? PutOI.toFixed(2) : 0}</td>

                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </div>
                    </section>
                </Col>
            </Row>
        </Container >

    );
}

export default OptChain;
